/* eslint-disable */

/** select columns of table "argo.pg_timezone_names" */
export enum ArgoPgTimezoneNamesSelectColumn {
  /** column name */
  Abbrev = 'abbrev',
  /** column name */
  IsDst = 'is_dst',
  /** column name */
  Name = 'name',
  /** column name */
  UtcOffset = 'utc_offset'
}

